import React, { PureComponent } from "react";
import InnerHTML from "../base/InnerHtml";
import { MetaTagsStatic } from "~/components/base/MetaTags";
import type { MetaTagsStaticProps } from "../base/MetaTags";

type StaticPageProps = {
  // canonical_url: string;
  // totalShareCount: number;
  image: string;
  // image_caption: string;
  // description: string;
  title: string;
  url: string;
  html: string;
}
export default class StaticPage extends PureComponent<StaticPageProps> {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const props = this.props;    

    const canonical_url = process.env.BUILD_TARGET !== "server" ? window.location.href : "";

    const metaData: MetaTagsStaticProps = {
      url: canonical_url,
      title: props.title,
      objectType: "page",
    };

    console.log("PROPS: ", props);
    return (
      <div>
        <MetaTagsStatic data={metaData} />
        <InnerHTML className="container static-page" html={props.html} />
      </div>
    );
  }
}
